// extracted by mini-css-extract-plugin
export default {"displayError":"displayError--Xsq_Z"};